import React, { useState, useEffect } from 'react'
import { getDueListByDateEv, DownloadDueListByDateEv } from '../../../AdminActionCreator.component'
import moment from 'moment'
import Loader from '../../../../../presentationals/Loader/Loader.component'

export default function Main() {
    const [loader, setLoader] = useState(false)
    const [payload, setPayload] = useState({
        sDate: moment(new Date()).format("YYYY-MM-DD"),
        eDate: moment(new Date()).format("YYYY-MM-DD"),
    })
    const [data, setData] = useState([])

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    useEffect(() => {
        getDueListByDateEvFn()
    }, [])


    const getDueListByDateEvFn = () => {
        const start = moment(payload?.sDate).format("DD-MM-YYYY")
        const end = moment(payload?.eDate).format("DD-MM-YYYY")
        setLoader(true)
        getDueListByDateEv(start, end, callback => {
            setLoader(false)
            setData(callback?.data || [])
        })
    }

    const handleApply = () => {
        getDueListByDateEvFn()
    }
    const handleDownload = () => {
        const start = moment(payload?.sDate).format("DD-MM-YYYY")
        const end = moment(payload?.eDate).format("DD-MM-YYYY")
        setLoader(true)
        DownloadDueListByDateEv(start, end, callback => {
            setLoader(false)
        })
    }



    return (
        <>
            {loader ? <Loader /> : ""}
            <div className="container-fluid">
                <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type='date' className='form-control' value={payload.sDate} onChange={(e) => handlechange(e, "sDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type='date' className='form-control' value={payload.eDate} onChange={(e) => handlechange(e, "eDate")} />
                    </div>
                    <div className="col-sm-3 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '22px' }}>
                        <button className='btn btn-primary' onClick={() => handleApply()}>Apply</button>
                        <button className='btn btn-primary' onClick={() => handleDownload()}>Download</button>
                    </div>


                    <div className='col-sm-12 col-xs-12' style={{ marginTop: '20px' }}>
                        <div>
                            <div className="overflow-x-auto">

                                <table className="phocket-table">
                                    <thead>
                                        <tr>
                                            <th>State</th>
                                            <th>City</th>
                                            <th>Application ID</th>
                                            <th>DO Number</th>
                                            <th>Salutation</th>
                                            <th>First Name</th>
                                            <th>Relation Prefix</th>
                                            <th>Relation Name</th>
                                            <th>Residence Type</th>
                                            <th>Permanent Address</th>
                                            <th>Permanent Landmark</th>
                                            <th>Permanent Police Station</th>
                                            <th>Permanent Pincode</th>
                                            <th>Current Address</th>
                                            <th>Current Landmark</th>
                                            <th>Current Police Station</th>
                                            <th>Current Pincode</th>
                                            <th>Mobile Number</th>
                                            <th>Alternate Number</th>
                                            <th>Co-Borrower Prefix</th>
                                            <th>Co-Borrower Name</th>
                                            <th>Co-Borrower Address</th>
                                            <th>Co-Borrower Pincode</th>
                                            <th>Co-Borrower Landmark</th>
                                            <th>Co-Borrower Police Station</th>
                                            <th>Co-Borrower Mobile 1</th>
                                            <th>Co-Borrower Mobile 2</th>
                                            <th>Guarantor Prefix</th>
                                            <th>Guarantor Name</th>
                                            <th>Guarantor Address</th>
                                            <th>Guarantor Pincode</th>
                                            <th>Guarantor Landmark</th>
                                            <th>Guarantor Police Station</th>
                                            <th>Guarantor Mobile 1</th>
                                            <th>Guarantor Mobile 2</th>
                                            <th>Reference Name</th>
                                            <th>Reference Relation</th>
                                            <th>Reference Phone</th>
                                            <th>Product</th>
                                            <th>Product Type</th>
                                            <th>Battery Serial Number</th>
                                            <th>Vehicle Registration Number</th>
                                            <th>Dealer Name</th>
                                            <th>Manufacturer</th>
                                            <th>Engine Number</th>
                                            <th>Chassis Number</th>
                                            <th>Registration Date</th>
                                            <th>Loan Type</th>
                                            <th>Category Name</th>
                                            <th>Loan Amount</th>
                                            <th>Tenure</th>
                                            <th>Loan Apply Date</th>
                                            <th>Loan Approve Amount</th>
                                            <th>Loan Status</th>
                                            <th>EMI</th>
                                            <th>Last Payment Date</th>
                                            <th>Last Payment Amount</th>
                                            <th>DPD</th>
                                            <th>EMI Number</th>
                                            <th>Total Received</th>
                                            <th>Total Due</th>
                                            <th>Installment Overdue Amount</th>
                                            <th>Loan Date</th>
                                            <th>End Date</th>
                                            <th>Finance Amount</th>
                                            <th>Agree Amount</th>
                                            <th>First EMI</th>
                                            <th>Interest Rate</th>
                                            <th>Frequency</th>
                                            <th>Principle</th>
                                            <th>Interest</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {data && data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.state}</td>
                                                    <td>{item.city}</td>
                                                    <td>{item.application_id}</td>
                                                    <td>{item.do_number}</td>
                                                    <td>{item.salutation}</td>
                                                    <td>{item.first_name}</td>
                                                    <td>{item.relation_prefix}</td>
                                                    <td>{item.relation_name}</td>
                                                    <td>{item.residence_type}</td>
                                                    <td style={{ whiteSpace: "wrap", minWidth: '150px' }}>{item.permanent_address}</td>
                                                    <td>{item.permanent_landmark}</td>
                                                    <td>{item.permanent_police_station}</td>
                                                    <td>{item.permanent_pincode}</td>
                                                    <td style={{ whiteSpace: "wrap", minWidth: '150px' }}>{item.current_address}</td>
                                                    <td>{item.current_landmark}</td>
                                                    <td>{item.current_police_station}</td>
                                                    <td>{item.current_pincode}</td>
                                                    <td>{item.mobile_number}</td>
                                                    <td>{item.alternate_number}</td>
                                                    <td>{item.co_borrower_prefix}</td>
                                                    <td>{item.co_borrower_name}</td>
                                                    <td style={{ whiteSpace: "wrap", minWidth: '150px' }}>{item.co_borrower_address}</td>
                                                    <td>{item.co_borrower_pincode}</td>
                                                    <td>{item.co_borrower_landmark}</td>
                                                    <td>{item.co_borrower_police_station}</td>
                                                    <td>{item.co_borrower_mobile1}</td>
                                                    <td>{item.co_borrower_mobile2}</td>
                                                    <td>{item.guarantor_prefix}</td>
                                                    <td>{item.guarantor_name}</td>
                                                    <td style={{ whiteSpace: "wrap", minWidth: '150px' }}>{item.guarantor_address}</td>
                                                    <td>{item.guarantor_pincode}</td>
                                                    <td>{item.guarantor_landmark}</td>
                                                    <td>{item.guarantor_police_station}</td>
                                                    <td>{item.guarantor_mobile1}</td>
                                                    <td>{item.guarantor_mobile2}</td>
                                                    <td>{item.reference_name}</td>
                                                    <td>{item.reference_relation}</td>
                                                    <td>{item.reference_phone}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.product_type}</td>
                                                    <td>{item.battery_serial_number}</td>
                                                    <td>{item.vehicle_registration_number}</td>
                                                    <td>{item.dealer_name}</td>
                                                    <td>{item.manufacturer}</td>
                                                    <td>{item.engine_number}</td>
                                                    <td>{item.chassis_number}</td>
                                                    <td>{item.registration_date}</td>
                                                    <td>{item.loan_type}</td>
                                                    <td>{item.category_name}</td>
                                                    <td>{item.loan_amount}</td>
                                                    <td>{item.tenure}</td>
                                                    <td>{item.loan_apply_date}</td>
                                                    <td>{item.loan_approve_amount}</td>
                                                    <td>{item.loan_status}</td>
                                                    <td>{item.Emi}</td>
                                                    <td>{item.lastPaymentDate}</td>
                                                    <td>{item.lastPaymentAmount}</td>
                                                    <td>{item.dpd}</td>
                                                    <td>{item.emiNumber}</td>
                                                    <td>{item.totalReceived}</td>
                                                    <td>{item.totalDue}</td>
                                                    <td>{item.installmentOverdueAmount}</td>
                                                    <td>{item.loanDate}</td>
                                                    <td>{item.endDate}</td>
                                                    <td>{item.financeAmonut}</td>
                                                    <td>{item.agreeAmonut}</td>
                                                    <td>{item.firstEmi}</td>
                                                    <td>{item.interestRate}</td>
                                                    <td>{item.Freq}</td>
                                                    <td>{item.principle}</td>
                                                    <td>{item.interest}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="77" style={{ textAlign: "center" }}>
                                                    No records found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>

                    </div>

                </div>


            </div>
        </>
    )
}
